import Icon from "@components/Icon/Icon";
import useStyles from "@hooks/useStyle";
import { Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { styles } from "./styles";
import { constants } from "./constants";
import { Icons } from "@utils/viewUtility";

const PageNotFound = () => {
	const { classes } = useStyles(styles) as any;

	return (
		<Grid container className={classes.container}>
			<Grid item>
				<Icon iconType={Icons.IC_PAGE_NOT_FOUND} />
			</Grid>
			<Grid className={classes.marginTop24} item>
				<Typography variant="h3">{constants.pageNotFoundHeader}</Typography>
			</Grid>
			<Grid item>
				<Typography variant="h5">{constants.pageNotFoundMessage}</Typography>
			</Grid>
			<Grid item>
				<Link className={classes.linkSizeColor} to="/">
					{constants.backToHome}
				</Link>
			</Grid>
		</Grid>
	);
};
export default PageNotFound;
